var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('LoginForm',{staticClass:"pb-16"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }